import React, { useEffect } from "react";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import styles from "./Profile.module.scss"
import {classNames} from "primereact/utils";
import {Chip} from "primereact/chip";
import {useTranslation} from "react-i18next";
import { useProfileQuery } from "./profileSlice";

export function Profile() {
    const { data: profile } = useProfileQuery();

    const {t} = useTranslation();



    return <div className="flex align-items-center justify-content-center" style={{width: '100%'}}>
        <div style={{maxWidth: '50%'}} className="flex align-self-start"/>
        <div style={{maxWidth: '50%'}}>
            {profile && <div className={classNames(styles.profile, "p-2")}>
                <h1>{t('title.profile')}</h1>
                <div className={"grid"}>
                    <div className={"col-12 md:col-6"}>
                        <label>{t('label.user')}</label>
                        <div className="field">
                            <InputText className="p-mr-2 p-d-inline" disabled={true} value={profile.username}/>
                        </div>
                    </div>
                    <div className={"col-12 md:col-6"}>
                        <label>{t('label.email')}</label>
                        <div className="field">
                            <InputText className="p-mr-2 p-d-inline" disabled={true} value={profile.email}/>
                        </div>
                    </div>
                    <div className={"col-12 md:col-6"}>
                        <label>{t('label.surname')}</label>
                        <div className="field">
                            <InputText className="p-mr-2 p-d-inline" disabled={true} value={profile.given_name}/>
                        </div>
                    </div>
                    <div className={"col-12 md:col-6"}>
                        <label>{t('label.name')}</label>
                        <div className="field">
                            <InputText className="p-mr-2 p-d-inline" disabled={true} value={profile.family_name}/>
                        </div>
                    </div>
                    <div className="col-12">
                        <Button type="button" className="p-button-danger" onClick={() => {window.location.href = '/api/logout';}}>
                            {t('button.logout')}
                        </Button>
                    </div>
                </div>

                <h1>{t("title.permission")}</h1>
                <div className={"grid"}>
                    {
                        profile.permissions && profile.permissions.map((p:any) => <div className={"col-12 md:col-3"}>
                            <Chip label={p}/>
                        </div>)
                    }
                    {
                        (!profile.permissions || profile.permissions.length === 0) &&  <div className={"col-12 md:col-3"}>
                            {t("message.permission.not")}
                        </div>
                    }
                </div>

            </div>
            }
        </div>
        <div style={{maxWidth: '50%'}} className="flex align-self-end"/>
    </div>
}
